"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.config = void 0;
var serviceURL = "/analyticsservice/v1/api";
var config = {
  analytics: serviceURL + "/analytics",
  analyticsSite: serviceURL + "/analytics/site",
  analyticsReport: serviceURL + "/analytics/report",
  analyticsSession: serviceURL + "/analytics/session",
  dataAndAlertSite: serviceURL + "/analytics/site/data-and-alert",
  dataAndAlertReport: serviceURL + "/analytics/report/data-and-alert",
  siteDataAndAlert: serviceURL + "/analytics/site/data-and-alert",
  reportDataAndAlert: serviceURL + "/analytics/report/data-and-alert",
  analyticsSnapshot: serviceURL + "/analytics/snapshot",
  analyticsSessionBulk: serviceURL + "/analytics/session/bulk",
  sessionAlertNotification: serviceURL + "/analytics/data-and-alert",
  changeLog: serviceURL + "/change-log",
  survey: serviceURL + "/analytics/survey"
};
exports.config = config;